document.addEventListener('DOMContentLoaded', function () {
  // Script annonce
  document.querySelectorAll('.announcement-bar__message span').forEach(function (el) {
    el.innerHTML = el.textContent
      .replace('gagne des points de fidélité', '<strong>gagne des points de fidélité</strong>')
      .replace('GRATUIT', '<strong>GRATUIT</strong>');
  });

  // Script titre bannière
  document.querySelectorAll('.banner__heading').forEach(function (el) {
    el.innerHTML = el.innerHTML.replace(
      'imprimés en 3D',
      '<span class="ligne-blanche">imprimés en 3D</span>'
    );
  });
});